import { isAgentPlatformGoogleEnabled, isAgentPlatformLocalEnabled } from './featureFlag';
import { isLocalAgentPlatformOrigin } from './configuration';

export const resolveGoogleConnectionsApiOrigin = (
  enabled = isAgentPlatformGoogleEnabled(),
  configuredApiBase = process.env.REACT_APP_AGENT_PLATFORM_GOOGLE_API_ORIGIN || (isAgentPlatformLocalEnabled() ? process.env.REACT_APP_AGENT_PLATFORM_API_ORIGIN : undefined),
  browserOrigin = typeof window !== 'undefined' ? window.location.origin : undefined,
  localEnabled = isAgentPlatformLocalEnabled(),
): string | undefined => {
  if (!enabled || !configuredApiBase || !browserOrigin) return undefined;
  try {
    const api = new URL(configuredApiBase);
    const browser = new URL(browserOrigin);
    if (localEnabled && isLocalAgentPlatformOrigin(api, browser)) return api.origin;
    if (api.protocol !== 'https:' || browser.protocol !== 'https:') return undefined;
    if (api.origin !== configuredApiBase.trim().replace(/\/$/, '')) return undefined;
    const dashboardLabels = browser.hostname.toLowerCase().split('.');
    if (dashboardLabels[0] !== 'app' || dashboardLabels.length < 3) return undefined;
    if (api.hostname.toLowerCase() !== `agents-api.${dashboardLabels.slice(1).join('.')}`) return undefined;
    return api.origin;
  } catch (_error) {
    return undefined;
  }
};

export const isTrustedGoogleAuthorizationUrl = (value: string): boolean => {
  try {
    const url = new URL(value);
    return url.origin === 'https://accounts.google.com'
      && url.pathname === '/o/oauth2/v2/auth'
      && !url.username
      && !url.password;
  } catch (_error) {
    return false;
  }
};
